import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-scroll";

const links = [
  { label: "About", to: "about" },
  { label: "Projects", to: "projects" },
  { label: "Contact", to: "contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
      style={{
        position: "fixed",
        top: 0, left: 0, right: 0,
        zIndex: 100,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "1.2rem 3rem",
        borderBottom: `1px solid ${scrolled ? "rgba(57,255,20,0.15)" : "rgba(30,30,30,0.8)"}`,
        background: "rgba(10,10,10,0.88)",
        backdropFilter: "blur(14px)",
        transition: "border-color 0.4s",
      }}
    >
      <motion.div
        style={{
          fontFamily: "var(--font-mono)",
          fontSize: "0.85rem",
          color: "var(--accent)",
          letterSpacing: "0.08em",
        }}
        whileHover={{ letterSpacing: "0.18em" }}
        transition={{ duration: 0.3 }}
      >
        YR_
      </motion.div>

      {/* Desktop Links */}
      <div style={{ display: "flex", gap: "2.5rem" }} className="nav-desktop">
        {links.map((link, i) => (
          <motion.div
            key={link.to}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 + i * 0.1 }}
          >
            <Link
              to={link.to}
              smooth={true}
              duration={600}
              offset={-80}
              style={{
                fontFamily: "var(--font-mono)",
                fontSize: "0.72rem",
                color: "var(--muted)",
                letterSpacing: "0.12em",
                textTransform: "uppercase",
                cursor: "none",
              }}
              className="nav-link"
            >
              <span style={{ color: "var(--accent)" }}>0{i + 1}.</span> {link.label}
            </Link>
          </motion.div>
        ))}
      </div>

      {/* Hamburger */}
      <button
        onClick={() => setMenuOpen(!menuOpen)}
        style={{
          display: "none",
          background: "none",
          border: "none",
          color: "var(--accent)",
          fontFamily: "var(--font-mono)",
          fontSize: "0.8rem",
        }}
        className="nav-hamburger"
      >
        {menuOpen ? "[X]" : "[≡]"}
      </button>

      {/* Mobile Menu */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            style={{
              position: "fixed",
              top: "64px",
              left: 0,
              right: 0,
              background: "rgba(10,10,10,0.97)",
              borderBottom: "1px solid var(--border)",
              padding: "2rem",
              display: "flex",
              flexDirection: "column",
              gap: "1.5rem",
            }}
          >
            {links.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                smooth={true}
                duration={600}
                offset={-80}
                onClick={() => setMenuOpen(false)}
                style={{
                  fontFamily: "var(--font-mono)",
                  fontSize: "1.1rem",
                  color: "var(--text)",
                  letterSpacing: "0.1em",
                  textTransform: "uppercase",
                  cursor: "none",
                }}
              >
                <span style={{ color: "var(--accent)" }}>→ </span>
                {link.label}
              </Link>
            ))}
          </motion.div>
        )}
      </AnimatePresence>

      <style>{`
        .nav-link:hover { color: var(--accent) !important; transition: color 0.2s; }
        @media (max-width: 768px) {
          .nav-desktop { display: none !important; }
          .nav-hamburger { display: block !important; }
        }
      `}</style>
    </motion.nav>
  );
}
